import React, { useEffect, useState } from "react";
import { FaChevronUp } from "react-icons/fa";

const SideBarButton = ({
  buttonItem,
  dashBoardState,
  setDashBoardState,
  first,
  truncate,
  setBankName,
  setImage,
}) => {
  const [expanded, setExpanded] = useState(false);

  const truncateText = (text, length) => {
    if (text === null || text === undefined) return "";
    if (text.length > length) {
      return text.slice(0, length) + "...";
    }
    return text;
  };
  const truncateFromBegining = (text, length) => {
    if (text === null || text === undefined) return "";
    if (text.length > length) {
      return "..." + text.slice(length, text.length);
    }
    return text;
  };
  return (
    <>
      <button
        onClick={() => {
          setExpanded(!expanded);
        }}
        className={` w-full h-[44px] py-[10px] flex items-center ${
          first && "mt-2"
        } `}
      >
        <span className=" w-6 h-6 rounded-full bg-[#f0f9ff] flex items-center justify-center mr-2">
          {typeof buttonItem.Icon == "string" ? (
            <img src={buttonItem.Icon} alt="icon" />
          ) : (
            <buttonItem.Icon size={13} />
          )}
        </span>
        <span className=" font-medium text-xs">
          {truncateText(buttonItem.title, 10)}
        </span>
        <span className="ml-auto mr-4">
          <FaChevronUp
            style={{
              transform: expanded ? "rotate(0deg)" : "rotate(180deg)",
              transition: "transform 0.3s",
            }}
            size={15}
            color="#00394d"
          />
        </span>
      </button>
      {expanded && (
        <>
          {buttonItem?.buttonItems?.map((item, index) => (
            <button
              onClick={() => {
                setDashBoardState(item.value);
                setBankName(buttonItem.title);
                setImage(buttonItem.Icon);
              }}
              key={index}
              className={` w-full   ${
                !first ? "h-[34px]" : "h-[44px]"
              } px-8 mt-2 flex items-center rounded-r-lg ${
                dashBoardState === item.value ? " bg-[#a0ff77]" : ""
              }`}
            >
              <span className=" font-medium text-xs">
                {truncate
                  ? truncateFromBegining(item.name, 6)
                  : item.name || "---"}
              </span>
            </button>
          ))}
        </>
      )}
    </>
  );
};

export default SideBarButton;
